import React from 'react'

import { RequestError } from '~/common/define/requestError'
import ErrorContent from '~/components/page/error/ErrorContent'
import OpenPageHad from '~/components/header/OpenPageHead'
import PublicLayout from '~/components/layout/PublicLayout'
import PageFrame from '~/components/wrapper/screen/PageFrame'

interface Props {
  error: RequestError
}

const ErrorLayoutPage = ({error}: Props) => {
  // Cannot use translation in error page
  const NOT_FOUND_TITLE = 'ページが存在しません'
  const ERROR_TITLE = '読み込みエラー'
  return (
    <PublicLayout isResponsive noBackGround>
      <OpenPageHad title={error == RequestError.NOT_FOUND ? NOT_FOUND_TITLE : ERROR_TITLE} />
      <PageFrame>
        <ErrorContent error={error} />
      </PageFrame>
    </PublicLayout>
  )
}

export default ErrorLayoutPage